import { useFormik } from "formik";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { chargingSchema } from "../../../lib/validations/chargingValidations";
import { createCharging } from "../../../apis/chargingApi";
import TextInputFormik from "../../../lib/common/TextInputFormik";

export default function AddCharging() {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      id: "",
      cardNumber: "",
    },
    validationSchema: chargingSchema,
    onSubmit: async (values) => {
      try {
        setLoading(true);
        const res = await createCharging(values);
        
        if (res?.result || res?.success) {
          formik.resetForm();
          // Navigate back or show success message
          alert("Transaction created successfully");
        } else {
            alert(res?.message);
          console.error("Error saving charging:", res);
        }
        setLoading(false);
      } catch (error) {
        console.error("Error submitting form:", error);
        setLoading(false);
      }
    },
  });

  const backClick = () => {
    navigate(-1);
  };

  return (
    <>
      <div className="main-wrapper">
        <div className="page-wrapper">
          <div className="content container-fluid">
            <i
              className="fas fa-arrow-left"
              style={{ marginRight: "30px", fontSize: "20px", cursor: "pointer" }}
              onClick={backClick}
            />
            <div className="my-3 p-3 bg-body rounded shadow-sm">
              <form onSubmit={formik.handleSubmit} className="formMaxwidth">
                {/* ID Field */}
                <TextInputFormik 
                  label="ID" 
                  field="id" 
                  formik={formik}
                  placeholder="Enter ID"
                />

                {/* Card Number Field */}
                <TextInputFormik
                  label="Card Number"
                  field="cardNumber"
                  formik={formik}
                  placeholder="Enter card number"
                />

                {/* Submit button or loading spinner */}
                {loading ? (
                  <div
                    className="d-flex justify-content-center align-items-center"
                    style={{ height: "50px", padding: "7px 30px" }}
                  >
                    <div className="spinner-border" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                ) : (
                  <button className="btn btn-primary" type="submit">
                    Submit
                  </button>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

